import { render, staticRenderFns } from "./BeingGreenVideoItem.vue?vue&type=template&id=5cecb1b4&scoped=true&"
import script from "./BeingGreenVideoItem.vue?vue&type=script&lang=js&"
export * from "./BeingGreenVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./BeingGreenVideoItem.vue?vue&type=style&index=0&id=5cecb1b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cecb1b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VImg,VRow})
